exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.social-networks__content[data-v-55318dfa]{display:flex;flex-direction:column;justify-content:space-between;margin-bottom:48px;margin-top:32px;width:284px\n}\n@media (min-width:992px){\n.social-networks__content[data-v-55318dfa]{display:flex;margin-left:48px;width:380px\n}\n}\n.social-networks__title[data-v-55318dfa]{margin-top:rem(16)\n}\n@media (min-width:768px){\n.social-networks__title[data-v-55318dfa]{margin-top:0\n}\n}\n.social-networks__text[data-v-55318dfa]{margin-bottom:32px;margin-top:8px\n}\n.social-networks__image[data-v-55318dfa]{cursor:pointer;margin-right:8px\n}", ""]);

// exports
